<template>
  <div class="backdrop">
    <h1>Select A Word</h1>
    <!-- {{ words }} -->
    <!-- {{roomId}} -->
    <div class="button-holder">
      <div v-for="word in threeWords">
        <button class="button-35" @click="wordSelected(word)">
          {{ word }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import * as socketio from '../plugins/socketio';
  import wordList from '../assets/wordList';

  export default {
    props: ['words', 'roomId'],
    data() {
      return {
        threeWords: '',
      };
    },
    mounted() {
      this.threeWords = wordList.threeRandomWordsGenerator();
      socketio.addEventListener({
        type: 'roomState',
        callback: (roomData) => {
          if (
            roomData.roundTime === 15 &&
            roomData.choosingWord &&
            roomData.roomMaster.playerSocketId === socketio.clientSocketId()
          ) {
            const word = this.threeWords[
              Math.floor(Math.random() * this.threeWords.length)
            ];
            this.wordSelected(word);
          }
        },
      });
    },
    methods: {
      wordSelected(word) {
        console.log('I sent:', word, 'to room', this.roomId);
        // socketio.sendEvent({
        //     type: 'wordSelected',
        //     data: {
        //         word: word,
        //         roomId: this.roomId
        //     }
        // })
        this.$emit('ISelectedWord', word);
      },
    },
  };
</script>

<style>
  .backdrop {
    top: 0;
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    color: aliceblue;
    width: 100%;
    height: 100%;
  }

  .button-holder {
    /* display: inline-flex;
    justify-content: space-between;
    min-height: 100vh; */
    min-height: 80vh; /* height of the browser viewport */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .button-35 {
    align-items: center;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: transparent 0 0 0 3px, rgba(18, 18, 18, 0.1) 0 6px 20px;
    box-sizing: border-box;
    color: #121212;
    cursor: pointer;
    display: inline-flex;
    flex: 1 1 auto;
    font-family: Inter, sans-serif;
    font-size: 1.2rem;
    font-weight: 700;
    justify-content: center;
    line-height: 1;
    margin: 12px;
    outline: none;
    padding: 1rem 1.2rem;
    text-align: center;
    text-decoration: none;
    transition: box-shadow 0.2s, -webkit-box-shadow 0.2s;
    white-space: nowrap;
    border: 0;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
  }

  .button-35:hover {
    box-shadow: #121212 0 0 0 3px, transparent 0 0 0 0;
  }
</style>
